import React from 'react';
import App from 'next/app';
import * as Analytics from '../src/components/analytics';
import ContentLayout from '../src/components/Layout/ContentLayout';
import '../src/scss/reset.scss';
import '../src/scss/_theme.scss';
import { fetchFeatureFlags } from '../src/utils/featureFlags';

function ContentApp({ Component, pageProps, featureFlags }) {
  return (
    <Analytics.Provider>
      <ContentLayout {...pageProps} featureFlags={featureFlags}>
        <Component {...pageProps} />
      </ContentLayout>
    </Analytics.Provider>
  );
}

ContentApp.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext);
  const featureFlags = fetchFeatureFlags(appContext.ctx);

  return { ...appProps, featureFlags };
};

export default ContentApp;
